import React from "react";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFetch, useLanguage } from "hooks";
import { API_ROUTES } from "constants";
import { useAlert } from "context";

function withContainer(WrappedCompoent) {
  return (props) => {
    const language = useLanguage();
    const [_, dispatchAlert] = useAlert();
    const schema = yup.object().shape(
      {
        old_password: yup.string().required(language.oldPasswordRequired),
        password: yup
          .string()
          .required(language.passwordRequired)
          .min(8, language.passwordMinLength)
          .max(30, language.passwordMaxLength),
        password_confirmation: yup
          .string()
          .required(language.passwordConfirmationRequired)
          .oneOf([yup.ref("password")], language.passwordsMustMatch),
      },
      []
    );
    const {
      register: registerField,
      handleSubmit,
      formState: { errors },
      watch,
      reset,
      setError,
    } = useForm({
      resolver: yupResolver(schema),
    });
    const values = watch();

    const [{ loading }, request] = useFetch(
      {
        method: "POST",
        endpoint: API_ROUTES.editUserPassword,
        body: {
          old_password: values.old_password,
          password: values.password,
          password_confirmation: values.password_confirmation,
        },
        onSuccess: () => {
          reset();
          dispatchAlert({
            type: "OPEN",
            payload: {
              icon: "success",
              title: language.success,
              text: language.passwordChangedSuccess,
              canDismiss: true,
            },
          });
        },
        onError: (err) => {
          reset();
          if (typeof err === "string") {
            dispatchAlert({
              type: "OPEN",
              payload: {
                icon: "attention",
                title: language.error,
                text: err,
                canDismiss: true,
              },
            });
          }
        },
      },
      [],
      false
    );

    const handleSubmitData = () => {
      request();
    };

    return (
      <WrappedCompoent
        loading={loading}
        registerField={registerField}
        handleSubmit={handleSubmit(handleSubmitData)}
        errors={errors}
      />
    );
  };
}
export default withContainer;
